export const STATUS_SCANEO = "STATUS_SCANEO"
export const LOADING_SCANEO = "LOADING_SCANEO"